module.exports = __webpack_public_path__ + "img/services.923e2a7a.jpg";